import React from 'react'
import { Input, Label } from 'semantic-ui-react'
import { StyleSheet } from 'aphrodite'
import { css } from 'aphrodite'

export const DollarField = ({
  meta = {},
  input = {},
  label,
  hint,
  ...props
}) => {
  const styles = getStyles(props, this.context)
  return (
    <Input
      error={!!(meta.touched && meta.error)}
      {...props}
      {...input}
      className={css(styles.root)}
    >
      <Label basic>$</Label>
      <input />
      <Label basic>USD</Label>
    </Input>
  )
}

const getStyles = () =>
  StyleSheet.create({
    root: {
      marginBottom: 15,
    },

    input: {
      paddingLeft: 0,
    },

    label: {
      display: 'block',
      marginBottom: 7,
    },

    hint: {
      marginTop: 7,
    },

    error: {
      marginTop: 7,
    },
  })



// WEBPACK FOOTER //
// ./src/components/DollarField.js